var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"display-200 heading-greeting"},[_vm._v(" "+_vm._s(_vm.$t('common.greeting'))+" "+_vm._s(_vm.getFirstName)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }